import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { URLS, APPLICATION_GLOBAL_SLUG, createMarkup, APPLICATION_NAME, replaceNbsp } from "src/_config";
import { useCmsApi } from "src/_common/hooks/actions/cms/cmsApiHook";
import { toast } from "react-toastify";
import Sponsor from "../common/Sponsor";

interface CmsContent {
  title?: string;
  long_description?: string;
}

export default function CmsPage() {
  const cmsApi = useCmsApi();
  const [content, setContent] = useState<CmsContent | string | null>(null);
  const { slug } = useParams<{ slug?: string }>();
  const history = useHistory();

  const goBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(URLS.HOME);
    }
  };

  const getCmsContentDetails = () => {
    const params = {
      game_slug: APPLICATION_GLOBAL_SLUG,
      slug: slug ?? "",
    };

    cmsApi.callGetCmsContent(
      params,
      (message: string, resp: unknown) => {
        if (resp && typeof resp === "object" && "list" in resp) {
          setContent((resp as { list: CmsContent }).list);
        } else {
          setContent("");
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    if (content && typeof content === "object" && "title" in content) {
      const prevTitle = document.title;
      document.title = `${APPLICATION_NAME} : ${content.title}`;
      return () => {
        document.title = prevTitle;
      };
    }
    return undefined;
  }, [content]);

  useEffect(() => {
    getCmsContentDetails();
  }, []);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <a onClick={goBack} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        {(typeof content === "object" && content !== null && "title" in content ? content.title : null) || <span>Back</span>}
        <hr className="color-white" />
      </h2>
      <hr className="color-white" />
      <div className="form-box-new">
        <div className="row">
          <p
            className="normal-text"
            dangerouslySetInnerHTML={createMarkup(
              (typeof content === "object" && content !== null && "long_description" in content && content.long_description) 
                ? replaceNbsp(content.long_description) 
                : "No content added!"
            )}
          />
        </div>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
